<template>
    <div>
        <section class="hero-wrap hero-wrap-2"
            :style="{backgroundImage: 'url(' + $Url + toposobreimg + ')',height: '250px'}">
            <div class="overlay"></div>
            <div class="container">
                <div class="row no-gutters slider-text align-items-center justify-content-center">
                    <div class="col-md-9 text-center">
                        <h1 class="mb-2 bread">{{toposobrenome}}</h1>
                        <p class="breadcrumbs"><span class="mr-2"><a href="/">Home <i
                                        class="ion-ios-arrow-forward"></i></a></span> <span>{{toposobrenome}} <i
                                    class="ion-ios-arrow-forward"></i></span></p>
                    </div>
                </div>
            </div>
        </section>
        <div class="section">
            <!-- container -->
            <div class="container">
                <!-- row -->
                <div class="row" style="text-align: center;">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                        <!-- Billing Details -->
                        <div class="billing-details">
                            <div class="section-title">
                                <h5 style="padding-bottom: 40px;padding-top: 60px;">{{Titulo}}</h5>
                                <p v-html="Texto"></p>
                            </div>
                            <div class="form-group">
                                <div class="estrelas" style="padding-top: 15px;">
                                    <input type="radio" id="cm_star-empty" name="fb" value="" checked />
                                    <label for="cm_star-1"><i class="fa" style="font-size: 30px;"></i></label>
                                    <input v-model="RadioChecked" type="radio" id="cm_star-1" name="fb" value="1" />
                                    <label for="cm_star-2"><i class="fa" style="font-size: 30px;"></i></label>
                                    <input v-model="RadioChecked" type="radio" id="cm_star-2" name="fb" value="2" />
                                    <label for="cm_star-3"><i class="fa" style="font-size: 30px;"></i></label>
                                    <input v-model="RadioChecked" type="radio" id="cm_star-3" name="fb" value="3" />
                                    <label for="cm_star-4"><i class="fa" style="font-size: 30px;"></i></label>
                                    <input v-model="RadioChecked" type="radio" id="cm_star-4" name="fb" value="4" />
                                    <label for="cm_star-5"><i class="fa" style="font-size: 30px;"></i></label>
                                    <input v-model="RadioChecked" type="radio" id="cm_star-5" name="fb" value="5" />
                                    <label for="cm_star-6"><i class="fa" style="font-size: 30px;"></i></label>
                                    <input v-model="RadioChecked" type="radio" id="cm_star-6" name="fb" value="6" />
                                    <label for="cm_star-7"><i class="fa" style="font-size: 30px;"></i></label>
                                    <input v-model="RadioChecked" type="radio" id="cm_star-7" name="fb" value="7" />
                                    <label for="cm_star-8"><i class="fa" style="font-size: 30px;"></i></label>
                                    <input v-model="RadioChecked" type="radio" id="cm_star-8" name="fb" value="8" />
                                    <label for="cm_star-9"><i class="fa" style="font-size: 30px;"></i></label>
                                    <input v-model="RadioChecked" type="radio" id="cm_star-9" name="fb" value="9" />
                                    <label for="cm_star-10"><i class="fa" style="font-size: 30px;"></i></label>
                                    <input v-model="RadioChecked" type="radio" id="cm_star-10" name="fb" value="10" />
                                </div>
                            </div>
                            <form class="bg-light p-5 contact-form">
                            <div class="form-group">
                                <textarea rows="8" class="input" v-model="Mensagem" placeholder="Mensagem" style="width: 100%;"></textarea>
                            </div>

                            <div class="form-group">
                                <span>Gostaria de receber nosso retorno?</span><br/>
                                <input type="text" v-model="Nome" class="form-control" placeholder="Nome">
                            </div>
                            <div class="form-group">
                                <input type="text" v-model="Email" class="form-control" placeholder="E-mail">
                            </div>
                            <div class="form-group">
                                <input type="text" v-model="Telefone" class="form-control" placeholder="Telefone">
                            </div>
                            <a href="#" @click.prevent="Enviar()" class="btn btn-primary py-3 px-5">Enviar</a>
                            </form>
                        </div>
                    </div>
                    <div class="col-md-3"></div>
                </div>
                <!-- /Order Details -->
            </div>
            <!-- /row -->
        </div>
        <!-- /container -->
    </div>
</template>

<script>
import moment from 'moment'
export default {
    components: {
    },
    data() {
        return {
            toposobre: [],
            toposobrenome: '',
            toposobreimg: '',

            Retorno: [],
            Titulo: '',
            EmailRecebe:'',
            Texto: '',
            Nome: '',
            Email: '',
            Telefone: '',
            Mensagem: '',
            RadioChecked:'',
        }
    },
    methods: {
        currentDateTime(vdate) {
            return moment(vdate).format('DD/MM/YYYY')
        },
        Enviar() {
            if (this.Nome == "") {
                this.$mensagem_normal("Por favor preencha o seu nome");
            } else if (this.Mensagem == "") {
                this.$mensagem_normal("Por favor preencha Mensagem");
            } else {
                let tmp = { ToEmail: this.EmailRecebe, Subject: 'Sugestão do Site', Body: "Estrelas: " + this.RadioChecked +  "<br/> Nome: " + this.Nome + " <br/> Telefone: " + this.Telefone + " <br/> E-mail: " + this.Email + " <br/> Mensagem:  " + this.Mensagem };
                this.$http
                    .post(
                        this.$apiUrl + "/contato/enviamail/" + 'Diproli', tmp
                    )
                    .then(
                        (response) => {
                            if (response.ok) {
                                this.$mensagem_normal("E-mail enviado com sucesso");
                                this.Nome = '';
                                this.Telefone = '';
                                this.Email = '';
                                this.Mensagem = '';
                                this.RadioChecked = '';

                            }
                        },
                        (error) => {
                            console.log(error);
                            this.$mensagem_erro(error.bodyText);
                        }
                    );
            }
        }
    },
    created() {

        this.$http
            .get(this.$apiUrl + "/institucional/telas/topoavaliações")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.toposobre = tiu2;

                if (this.toposobre != null) {
                    this.toposobrenome = this.toposobre[0].nome
                    if (this.toposobre[0].institucionalImg != '') {
                        this.toposobreimg = this.toposobre[0].institucionalImg[0].urlImagem
                    }
                    else {
                        this.toposobreimg = '';
                    }
                }

            });

        this.$http
            .get(this.$apiUrl + "/institucional/telas/textoavaliações")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.Retorno = tiu2;

                if (this.Retorno != null) {
                    this.Titulo = this.Retorno[0].nome;
                    this.EmailRecebe = this.Retorno[0].referencia;
                    this.Texto = this.Retorno[0].resumo1;
                }

            });
    },
    mounted() {

    },
}
</script>

<style>
	.estrelas input[type=radio] {
  display: none;
}
.estrelas label i.fa:before {
  content:'\f005';
  color: #FC0;
}
.estrelas input[type=radio]:checked ~ label i.fa:before {
  color: #CCC;
}
</style>